import { createAction } from "@reduxjs/toolkit";
import axios from 'apis';
import { asyncThunkWrapper } from "helpers/asyncThunkWrapper";

export const getStudyTasks = asyncThunkWrapper({ 
  model: 'studyTasks', 
  action: 'getStudyTasks', 
  func: async ({ id, offset = 0 }) => {
    const attributes = ['id', { file: ['id', 'filename'] }, 'input', 'status', 'updated_at'];
    const params = { limit: 25, offset, orders: { updated_at: 'desc' }, attributes };
    const response = await axios.get(`/study_analyses/${id}/study_tasks`, { params });

    return response.data;
  } 
});
export const getStudyTask = asyncThunkWrapper({ 
  model: 'studyTasks', 
  action: 'getStudyTask', 
  func: async (id) => {
    const attributes = [
      'id', 
      { file: ['id', 'filename', 'content_type', 'url'] },
      'input',
      'status', 
      'updated_at'
    ];
    const params = { attributes };
    const response = await axios.get(`/study_tasks/${id}`, { params });

    return response.data;
  } 
});
export const clearLocalStudyTasks = createAction('studyTasks/clearLocalStudyTasks');
export const clearLocalActiveStudyTask = createAction('studyTasks/clearLocalActiveStudyTask');